import moment from 'moment'

type NotificationLike = {
    scheduleDate: string
    scheduleTime: string
    message?: string
}

const POPUP_DAYS = 90

// Newest first, returns a copy so the shared notifications prop is left alone
export function sortNotificationsByScheduled<T extends NotificationLike>(notifications: T[]) {
    return [...notifications].sort((a, b) => {
        const aScheduled = moment(`${a.scheduleDate} ${a.scheduleTime}`).valueOf()
        const bScheduled = moment(`${b.scheduleDate} ${b.scheduleTime}`).valueOf()

        return bScheduled - aScheduled
    })
}

// The login popup only shows notifications of the last 90 days, the notifications page shows a longer period
export function isWithinPopupPeriod(notification: NotificationLike) {
    return notification.scheduleDate >= moment().subtract(POPUP_DAYS, 'days').format('YYYY-MM-DD')
}

// First line of the HTML message as plain text, for the list on the notifications page
export function getNotificationFirstLine(message = '') {
    const text = message
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, '\'')
        .replace(/&amp;/g, '&')

    return text.split('\n').map((line) => line.trim()).find((line) => line) || ''
}
